import axios, { AxiosError } from "axios";

const SDK_BASE_URL = (import.meta.env.VITE_SDK_BASE_URL || "https://koiosops.com/zalo-login").replace(/\/+$/, "");

export const api = axios.create({
  baseURL: SDK_BASE_URL,
  timeout: 30_000,
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" }
});

api.interceptors.response.use(
  (r) => r,
  (err: AxiosError) => {
    if (err.response?.status === 401 && window.location.pathname !== "/error/no-session") {
      window.location.replace("/error/no-session");
    }
    return Promise.reject(err);
  }
);
